module.exports = __webpack_public_path__ + "img/logo-ampro.85eea079.png";